/**
 * Generated by orval v8.0.0-rc.2 🍺
 * Do not edit manually.
 * SEMO API
 * ## SEMO MVP REST API

한국 서비스 마켓플레이스 백엔드 API 문서. 인증, 채팅, 견적, 계약, 결제를 포함합니다.

**버전**: `v0.1.0`
 * OpenAPI spec version: 0.1.0
 */
import * as zod from "zod";

/**
 * @summary 견적 요청 생성
 */
export const quoteRequestsControllerCreateBodyManagerNameMax = 100;

export const quoteRequestsControllerCreateBodyPaymentMethodDefault = "postpaid";
export const quoteRequestsControllerCreateBodyItemsItemAmountMin = 0;

export const quoteRequestsControllerCreateBody = zod
  .object({
    projectName: zod
      .string()
      .optional()
      .describe(
        "프로젝트명 (물품 구매(product) 카테고리는 선택 — 미입력 시 물품 목록으로 자동 생성, 그 외 카테고리는 필수)",
      ),
    categoryType: zod
      .enum(["product", "construction", "manufacturing", "used"])
      .describe("카테고리 타입"),
    managerContact: zod.string().describe("담당자 연락처 (필수)"),
    managerName: zod
      .string()
      .max(quoteRequestsControllerCreateBodyManagerNameMax)
      .describe("담당자명"),
    addressId: zod.string().describe("주소 ID (addresses 테이블 외래키)"),
    addressDetail: zod
      .string()
      .nullish()
      .describe("주소 상세정보 (예: 동 101호, 3층 등의 추가 정보)"),
    description: zod.string().nullish().describe("견적 요청 설명 및 추가 사항"),
    budgetType: zod
      .enum(["public", "no_budget"])
      .nullish()
      .describe("예산 타입"),
    budgetAmount: zod.number().nullish().describe("예산 금액 (원화)"),
    paymentMethod: zod
      .enum(["prepaid", "postpaid"])
      .default(quoteRequestsControllerCreateBodyPaymentMethodDefault)
      .describe("결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)"),
    preferredPaymentChannel: zod
      .enum(["card", "cash", "undecided"])
      .optional()
      .describe(
        "공고 결제방법. card/cash/undecided. 미전달 시 미결정으로 취급. paymentMethod(선결제/후불)와 다른 축이다.",
      ),
    sameRegionOnly: zod.boolean().nullish().describe("동일 지역만 선택 여부"),
    isPublic: zod.boolean().nullish().describe("공개 여부"),
    dueDateValue: zod
      .enum(["구체적", "협의가능"])
      .nullish()
      .describe("배송일 값 (사용자 입력값)"),
    dueDate: zod.string().nullish().describe("배송일 (ISO 8601 형식)"),
    attachments: zod
      .array(
        zod
          .object({
            fileName: zod.string().describe("파일명"),
            url: zod.string().url().describe("파일 공개 URL"),
            filePath: zod
              .string()
              .optional()
              .describe(
                "스토리지 내부 경로. 전달 시 백엔드가 매 조회마다 fresh signed URL을 재발급합니다.",
              ),
            fileSize: zod.number().describe("파일 크기 (바이트)"),
            contentType: zod.string().optional().describe("MIME 타입"),
          })
          .strict(),
      )
      .nullish()
      .describe("업로드된 파일들의 메타데이터 배열"),
    items: zod
      .array(
        zod
          .object({
            name: zod.string().describe("품목명"),
            quantity: zod.number().min(1).describe("수량"),
            unit: zod.string().describe("단위 (예: 세트, EA, 박스)"),
            amount: zod
              .number()
              .min(quoteRequestsControllerCreateBodyItemsItemAmountMin)
              .describe("금액 (원 단위, 예상 금액 또는 0)"),
            spec1: zod.string().optional().describe("규격 1"),
            spec2: zod.string().optional().describe("규격 2"),
            spec3: zod.string().optional().describe("규격 3"),
            itemCode: zod.string().optional().describe("품목 코드"),
            manufacturer: zod.string().optional().describe("제조사"),
            brand: zod.string().optional().describe("브랜드"),
            itemId: zod
              .string()
              .optional()
              .describe(
                "품목 ID (items_v2_base.id) - 자동완성 선택 시에만 제공",
              ),
          })
          .strict(),
      )
      .nullish()
      .describe("항목 목록 (Product 카테고리에만 필수)"),
    additionalConditions: zod
      .array(
        zod
          .object({
            value: zod.string().describe("English code identifier"),
            label: zod.string().describe("Korean UI label for display"),
          })
          .strict(),
      )
      .nullish()
      .describe("추가 조건 (물품 구매 카테고리 전용)"),
    additionalRequests: zod
      .array(
        zod
          .object({
            value: zod.string().describe("English code identifier"),
            label: zod.string().describe("Korean UI label for display"),
          })
          .strict(),
      )
      .nullish()
      .describe("추가 요청사항 (모든 카테고리 선택 가능)"),
    constructionType: zod
      .object({
        value: zod
          .enum([
            "facility_maintenance",
            "interior_architecture",
            "waterproofing_plaster_painting",
            "mechanical_equipment",
            "metal_structure_window",
            "paving",
            "electrical",
            "scaffolding_demolition",
            "asbestos_removal",
            "rebar_concrete",
            "fire_safety",
            "landscaping",
            "roofing_assembly",
            "elevator",
            "gas_facility",
            "hvac",
            "telecommunications",
            "cctv",
            "365_corner",
            "civil_construction",
            "building_construction",
            "specialized_construction",
            "water_sewage",
            "stone_work",
            "earthwork",
            "grouting",
            "dredging",
            "outdoor_signage",
            "other",
          ])
          .describe("Construction type code"),
        label: zod.string().describe("Korean label for display"),
      })
      .strict()
      .nullish()
      .describe("공사 타입 (공사 카테고리 전용)"),
    spaceType: zod
      .object({
        value: zod
          .enum(["office", "retail", "factory", "warehouse"])
          .describe("Space type code"),
        label: zod.string().describe("Korean label for display"),
      })
      .strict()
      .nullish()
      .describe("공간 타입 (공사 카테고리 전용)"),
    constructionArea: zod
      .object({
        value: zod
          .enum(["30", "50", "100", "200"])
          .describe("Construction area code"),
        label: zod.string().describe("Korean label for display"),
      })
      .strict()
      .nullish()
      .describe("공사 면적 (공사 카테고리 전용)"),
  })
  .strict();

/**
 * @summary 내 견적 요청 목록
 */
export const quoteRequestsControllerFindMyQuotesQueryPageDefault = 1;

export const quoteRequestsControllerFindMyQuotesQueryLimitDefault = 20;
export const quoteRequestsControllerFindMyQuotesQueryLimitMax = 100;

export const quoteRequestsControllerFindMyQuotesQuerySortByDefault =
  "created_at";
export const quoteRequestsControllerFindMyQuotesQuerySortOrderDefault = "desc";

export const quoteRequestsControllerFindMyQuotesQueryParams = zod
  .object({
    page: zod.coerce
      .number()
      .min(1)
      .default(quoteRequestsControllerFindMyQuotesQueryPageDefault)
      .describe("페이지 번호"),
    limit: zod.coerce
      .number()
      .min(1)
      .max(quoteRequestsControllerFindMyQuotesQueryLimitMax)
      .default(quoteRequestsControllerFindMyQuotesQueryLimitDefault)
      .describe("페이지당 항목 수"),
    sortBy: zod.coerce
      .string()
      .default(quoteRequestsControllerFindMyQuotesQuerySortByDefault)
      .describe("정렬 필드"),
    sortOrder: zod
      .enum(["asc", "desc"])
      .default(quoteRequestsControllerFindMyQuotesQuerySortOrderDefault)
      .describe("정렬 순서"),
    search: zod.coerce.string().optional().describe("검색어"),
    statuses: zod
      .array(
        zod.enum(["IN_PROGRESS", "ON_HOLD", "CLOSED", "CONTRACT_IN_PROGRESS"]),
      )
      .optional()
      .describe("상태 필터"),
  })
  .strict();

export const quoteRequestsControllerFindMyQuotesResponseTwoDataItemsItemPaymentMethodDefault =
  "postpaid";

export const quoteRequestsControllerFindMyQuotesResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod.string().describe("견적 요청 ID (UUID)"),
              requestNumber: zod.string().describe("견적 요청 번호"),
              projectName: zod.string().describe("프로젝트명"),
              organizationName: zod
                .string()
                .nullish()
                .describe(
                  "발주기관 이름 (공개 공고에서만. 비공개 공고는 본인·어드민 외 null. 기관명이 없는 구매자는 null)",
                ),
              status: zod
                .enum([
                  "IN_PROGRESS",
                  "ON_HOLD",
                  "CLOSED",
                  "CONTRACT_IN_PROGRESS",
                ])
                .describe("상태"),
              categoryType: zod
                .enum(["product", "construction", "manufacturing", "used"])
                .describe("카테고리 타입"),
              deadline: zod.string().describe("마감일"),
              createdAt: zod.string().nullish().describe("생성일 (ISO 8601)"),
              updatedAt: zod.string().nullish().describe("수정일 (ISO 8601)"),
              userId: zod.string().describe("사용자 ID (UUID)"),
              managerName: zod.string().nullish().describe("담당자명"),
              managerContact: zod.string().nullish().describe("담당자 연락처"),
              addressId: zod.string().nullish().describe("주소 ID"),
              address: zod
                .object({
                  province: zod.string().describe("시/도"),
                  city: zod.string().describe("시/군/구"),
                  district: zod.string().nullish().describe("읍/면/동"),
                  label: zod
                    .string()
                    .nullish()
                    .describe("배송지 이름 (예: 회사) (작성자 본인만)"),
                  postalCode: zod
                    .string()
                    .nullish()
                    .describe("우편번호 (작성자 본인만)"),
                  addressLine1: zod
                    .string()
                    .nullish()
                    .describe("기본주소 (작성자 본인만)"),
                  addressLine2: zod
                    .string()
                    .nullish()
                    .describe("상세주소 (작성자 본인만)"),
                  recipientName: zod
                    .string()
                    .nullish()
                    .describe("수령인 (작성자 본인만)"),
                })
                .strict()
                .nullish()
                .describe("지역 정보"),
              sameRegionOnly: zod.boolean().nullish().describe("동일 지역만"),
              budgetType: zod
                .enum(["public", "no_budget"])
                .nullish()
                .describe("예산 타입"),
              budgetAmount: zod.number().nullish().describe("예산 금액"),
              paymentMethod: zod
                .enum(["prepaid", "postpaid"])
                .describe(
                  "결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)",
                ),
              isPrepaid: zod
                .boolean()
                .describe(
                  "결제 방법 (boolean form). true=선결제, false=후불결제.",
                ),
              preferredPaymentChannel: zod
                .enum(["card", "cash", "undecided"])
                .nullable()
                .describe(
                  "공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.",
                ),
              isPublic: zod.boolean().nullish().describe("공개 여부"),
              dueDateValue: zod
                .enum(["구체적", "협의가능"])
                .nullish()
                .describe("배송일 (구체적/협의가능)"),
              dueDate: zod
                .string()
                .nullish()
                .describe("희망 배송일 (ISO 8601)"),
              constructionType: zod
                .object({
                  value: zod
                    .enum([
                      "facility_maintenance",
                      "interior_architecture",
                      "waterproofing_plaster_painting",
                      "mechanical_equipment",
                      "metal_structure_window",
                      "paving",
                      "electrical",
                      "scaffolding_demolition",
                      "asbestos_removal",
                      "rebar_concrete",
                      "fire_safety",
                      "landscaping",
                      "roofing_assembly",
                      "elevator",
                      "gas_facility",
                      "hvac",
                      "telecommunications",
                      "cctv",
                      "365_corner",
                      "civil_construction",
                      "building_construction",
                      "specialized_construction",
                      "water_sewage",
                      "stone_work",
                      "earthwork",
                      "grouting",
                      "dredging",
                      "outdoor_signage",
                      "other",
                    ])
                    .describe("Construction type code"),
                  label: zod.string().describe("Korean label for display"),
                })
                .strict()
                .nullish()
                .describe("공사 유형"),
              spaceType: zod
                .object({
                  value: zod
                    .enum(["office", "retail", "factory", "warehouse"])
                    .describe("Space type code"),
                  label: zod.string().describe("Korean label for display"),
                })
                .strict()
                .nullish()
                .describe("공간 유형"),
              constructionArea: zod
                .object({
                  value: zod
                    .enum(["30", "50", "100", "200"])
                    .describe("Construction area code"),
                  label: zod.string().describe("Korean label for display"),
                })
                .strict()
                .nullish()
                .describe("공사 면적"),
              responseCount: zod.number().describe("받은 견적 응답 개수"),
              hasResponded: zod
                .boolean()
                .nullish()
                .describe("현재 판매자의 응답 여부"),
              quoteResponseId: zod
                .string()
                .optional()
                .describe("판매자가 작성한 견적 응답 ID"),
              canAutoQuote: zod
                .boolean()
                .optional()
                .describe("자동 견적 가능 여부 (공급자 전용)"),
              hasMyContract: zod
                .boolean()
                .nullish()
                .describe(
                  "현재 판매자 본인의 비취소 계약 존재 여부 (공급자 전용). 견적요청 단위 status=CONTRACT_IN_PROGRESS 와 달리 타사 계약에는 켜지지 않는다. null=판정 불가(발주기관 조회 등).",
                ),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 자동 견적 가능 여부 실시간 체크
 */
export const quoteRequestsControllerCheckAutoQuoteBody = zod
  .object({
    items: zod
      .array(
        zod
          .object({
            name: zod.string().describe("항목명"),
            itemId: zod
              .string()
              .optional()
              .describe("마스터 품목 ID (Autocomplete 선택 시)"),
          })
          .strict(),
      )
      .describe("체크할 항목 목록"),
  })
  .strict();

export const quoteRequestsControllerCheckAutoQuoteResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        canAutoQuote: zod.boolean().describe("전체 품목 자동 견적 가능 여부"),
        supplierCount: zod
          .number()
          .describe(
            "전체 품목 매칭 시 업체 수 (canAutoQuote가 true일 때만 의미 있음)",
          ),
        suggestedBundles: zod
          .array(
            zod
              .object({
                itemNames: zod
                  .array(zod.string())
                  .describe("번들에 포함된 품목명 목록"),
                supplierCount: zod
                  .number()
                  .describe("이 조합을 처리 가능한 업체 수"),
                coverage: zod
                  .number()
                  .describe("전체 품목 대비 커버리지 (0~1)"),
              })
              .strict(),
          )
          .optional()
          .describe("즉시 견적 가능한 최적의 품목 조합 추천 목록"),
        itemAnalysis: zod
          .array(
            zod
              .object({
                name: zod.string().describe("품목명"),
                itemId: zod.string().optional().describe("마스터 품목 ID"),
                status: zod
                  .enum(["matched", "bundle_conflict", "no_supplier"])
                  .describe("매칭 상태"),
                supplierCount: zod
                  .number()
                  .describe("이 품목을 취급하는 총 업체 수"),
              })
              .strict(),
          )
          .optional()
          .describe("품목별 상세 분석 결과"),
        unmatchedItemNames: zod
          .array(zod.string())
          .optional()
          .describe(
            "자동 견적이 불가능하게 만드는 품목명 목록 (하위 호환성 유지)",
          ),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 공개 견적 요청 목록 조회
 */
export const quoteRequestsControllerFindPublicQueryPageDefault = 1;

export const quoteRequestsControllerFindPublicQueryLimitDefault = 20;
export const quoteRequestsControllerFindPublicQueryLimitMax = 100;

export const quoteRequestsControllerFindPublicQuerySortByDefault = "created_at";
export const quoteRequestsControllerFindPublicQuerySortOrderDefault = "desc";

export const quoteRequestsControllerFindPublicQueryParams = zod
  .object({
    page: zod.coerce
      .number()
      .min(1)
      .default(quoteRequestsControllerFindPublicQueryPageDefault)
      .describe("페이지 번호"),
    limit: zod.coerce
      .number()
      .min(1)
      .max(quoteRequestsControllerFindPublicQueryLimitMax)
      .default(quoteRequestsControllerFindPublicQueryLimitDefault)
      .describe("페이지당 항목 수"),
    sortBy: zod.coerce
      .string()
      .default(quoteRequestsControllerFindPublicQuerySortByDefault)
      .describe("정렬 필드"),
    sortOrder: zod
      .enum(["asc", "desc"])
      .default(quoteRequestsControllerFindPublicQuerySortOrderDefault)
      .describe("정렬 순서"),
    search: zod.coerce.string().optional().describe("검색어"),
    statuses: zod
      .array(
        zod.enum(["IN_PROGRESS", "ON_HOLD", "CLOSED", "CONTRACT_IN_PROGRESS"]),
      )
      .optional()
      .describe("상태 필터"),
  })
  .strict();

export const quoteRequestsControllerFindPublicResponseTwoDataItemsItemPaymentMethodDefault =
  "postpaid";

export const quoteRequestsControllerFindPublicResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod.string().describe("견적 요청 ID (UUID)"),
              requestNumber: zod.string().describe("견적 요청 번호"),
              projectName: zod.string().describe("프로젝트명"),
              organizationName: zod
                .string()
                .nullish()
                .describe(
                  "발주기관 이름 (공개 공고에서만. 비공개 공고는 본인·어드민 외 null. 기관명이 없는 구매자는 null)",
                ),
              status: zod
                .enum([
                  "IN_PROGRESS",
                  "ON_HOLD",
                  "CLOSED",
                  "CONTRACT_IN_PROGRESS",
                ])
                .describe("상태"),
              categoryType: zod
                .enum(["product", "construction", "manufacturing", "used"])
                .describe("카테고리 타입"),
              deadline: zod.string().describe("마감일"),
              createdAt: zod.string().nullish().describe("생성일 (ISO 8601)"),
              updatedAt: zod.string().nullish().describe("수정일 (ISO 8601)"),
              userId: zod.string().describe("사용자 ID (UUID)"),
              managerName: zod.string().nullish().describe("담당자명"),
              managerContact: zod.string().nullish().describe("담당자 연락처"),
              addressId: zod.string().nullish().describe("주소 ID"),
              address: zod
                .object({
                  province: zod.string().describe("시/도"),
                  city: zod.string().describe("시/군/구"),
                  district: zod.string().nullish().describe("읍/면/동"),
                  label: zod
                    .string()
                    .nullish()
                    .describe("배송지 이름 (예: 회사) (작성자 본인만)"),
                  postalCode: zod
                    .string()
                    .nullish()
                    .describe("우편번호 (작성자 본인만)"),
                  addressLine1: zod
                    .string()
                    .nullish()
                    .describe("기본주소 (작성자 본인만)"),
                  addressLine2: zod
                    .string()
                    .nullish()
                    .describe("상세주소 (작성자 본인만)"),
                  recipientName: zod
                    .string()
                    .nullish()
                    .describe("수령인 (작성자 본인만)"),
                })
                .strict()
                .nullish()
                .describe("지역 정보"),
              sameRegionOnly: zod.boolean().nullish().describe("동일 지역만"),
              budgetType: zod
                .enum(["public", "no_budget"])
                .nullish()
                .describe("예산 타입"),
              budgetAmount: zod.number().nullish().describe("예산 금액"),
              paymentMethod: zod
                .enum(["prepaid", "postpaid"])
                .describe(
                  "결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)",
                ),
              isPrepaid: zod
                .boolean()
                .describe(
                  "결제 방법 (boolean form). true=선결제, false=후불결제.",
                ),
              preferredPaymentChannel: zod
                .enum(["card", "cash", "undecided"])
                .nullable()
                .describe(
                  "공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.",
                ),
              isPublic: zod.boolean().nullish().describe("공개 여부"),
              dueDateValue: zod
                .enum(["구체적", "협의가능"])
                .nullish()
                .describe("배송일 (구체적/협의가능)"),
              dueDate: zod
                .string()
                .nullish()
                .describe("희망 배송일 (ISO 8601)"),
              constructionType: zod
                .object({
                  value: zod
                    .enum([
                      "facility_maintenance",
                      "interior_architecture",
                      "waterproofing_plaster_painting",
                      "mechanical_equipment",
                      "metal_structure_window",
                      "paving",
                      "electrical",
                      "scaffolding_demolition",
                      "asbestos_removal",
                      "rebar_concrete",
                      "fire_safety",
                      "landscaping",
                      "roofing_assembly",
                      "elevator",
                      "gas_facility",
                      "hvac",
                      "telecommunications",
                      "cctv",
                      "365_corner",
                      "civil_construction",
                      "building_construction",
                      "specialized_construction",
                      "water_sewage",
                      "stone_work",
                      "earthwork",
                      "grouting",
                      "dredging",
                      "outdoor_signage",
                      "other",
                    ])
                    .describe("Construction type code"),
                  label: zod.string().describe("Korean label for display"),
                })
                .strict()
                .nullish()
                .describe("공사 유형"),
              spaceType: zod
                .object({
                  value: zod
                    .enum(["office", "retail", "factory", "warehouse"])
                    .describe("Space type code"),
                  label: zod.string().describe("Korean label for display"),
                })
                .strict()
                .nullish()
                .describe("공간 유형"),
              constructionArea: zod
                .object({
                  value: zod
                    .enum(["30", "50", "100", "200"])
                    .describe("Construction area code"),
                  label: zod.string().describe("Korean label for display"),
                })
                .strict()
                .nullish()
                .describe("공사 면적"),
              responseCount: zod.number().describe("받은 견적 응답 개수"),
              hasResponded: zod
                .boolean()
                .nullish()
                .describe("현재 판매자의 응답 여부"),
              quoteResponseId: zod
                .string()
                .optional()
                .describe("판매자가 작성한 견적 응답 ID"),
              canAutoQuote: zod
                .boolean()
                .optional()
                .describe("자동 견적 가능 여부 (공급자 전용)"),
              hasMyContract: zod
                .boolean()
                .nullish()
                .describe(
                  "현재 판매자 본인의 비취소 계약 존재 여부 (공급자 전용). 견적요청 단위 status=CONTRACT_IN_PROGRESS 와 달리 타사 계약에는 켜지지 않는다. null=판정 불가(발주기관 조회 등).",
                ),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 견적 요청 상세 조회
 */
export const quoteRequestsControllerFindOneParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const quoteRequestsControllerFindOneResponseTwoDataPaymentMethodDefault =
  "postpaid";

export const quoteRequestsControllerFindOneResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("견적 요청 ID (UUID)"),
        requestNumber: zod.string().describe("견적 요청 번호"),
        projectName: zod.string().describe("프로젝트명"),
        userId: zod.string().describe("사용자 ID (작성자)"),
        isOwner: zod
          .boolean()
          .optional()
          .describe(
            "현재 인증 사용자가 이 견적 요청의 등록자인지 여부 (클라이언트 소유권 판단용)",
          ),
        status: zod
          .enum(["IN_PROGRESS", "ON_HOLD", "CLOSED", "CONTRACT_IN_PROGRESS"])
          .describe("상태"),
        categoryType: zod.enum(["product"]).describe("카테고리 타입"),
        managerName: zod.string().nullish().describe("담당자명"),
        managerContact: zod.string().nullish().describe("담당자 연락처"),
        organizationName: zod
          .string()
          .nullish()
          .describe(
            "발주기관 이름 (공개 공고에서만. 비공개 공고는 본인·어드민 외 null. 기관명이 없는 구매자는 null)",
          ),
        organizationPhone: zod
          .string()
          .nullish()
          .describe(
            "발주기관 대표번호 (담당자 개인 휴대폰이 아니다. 공개 공고에서만, 비공개는 본인·어드민 외 null)",
          ),
        addressId: zod.string().describe("주소 ID"),
        address: zod
          .object({
            province: zod.string().describe("시/도"),
            city: zod.string().describe("시/군/구"),
            district: zod.string().nullish().describe("읍/면/동"),
            label: zod
              .string()
              .nullish()
              .describe("배송지 이름 (예: 회사) (작성자 본인만)"),
            postalCode: zod
              .string()
              .nullish()
              .describe("우편번호 (작성자 본인만)"),
            addressLine1: zod
              .string()
              .nullish()
              .describe("기본주소 (작성자 본인만)"),
            addressLine2: zod
              .string()
              .nullish()
              .describe("상세주소 (작성자 본인만)"),
            recipientName: zod
              .string()
              .nullish()
              .describe("수령인 (작성자 본인만)"),
          })
          .strict()
          .nullish()
          .describe("주소 정보"),
        description: zod.string().nullish().describe("설명"),
        budgetType: zod
          .enum(["public", "no_budget"])
          .nullish()
          .describe("예산 타입"),
        budgetAmount: zod.number().nullish().describe("예산 금액"),
        paymentMethod: zod
          .enum(["prepaid", "postpaid"])
          .describe("결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)"),
        isPrepaid: zod
          .boolean()
          .describe("결제 방법 (boolean form). true=선결제, false=후불결제."),
        preferredPaymentChannel: zod
          .enum(["card", "cash", "undecided"])
          .nullable()
          .describe(
            "공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.",
          ),
        sameRegionOnly: zod.boolean().nullish().describe("동일 지역만"),
        isPublic: zod.boolean().nullish().describe("공개 여부"),
        deadline: zod.string().describe("마감일"),
        createdAt: zod.string().nullish().describe("생성일 (ISO 8601)"),
        updatedAt: zod.string().nullish().describe("수정일 (ISO 8601)"),
        approvedAt: zod.string().nullish().describe("승인 일시 (ISO 8601)"),
        closedAt: zod.string().nullish().describe("마감 일시 (ISO 8601)"),
        closeReason: zod.string().nullish().describe("마감 사유"),
        onHoldAt: zod.string().nullish().describe("보류 일시 (ISO 8601)"),
        attachments: zod
          .array(
            zod
              .object({
                fileName: zod.string().describe("파일명"),
                url: zod.string().url().describe("파일 공개 URL"),
                filePath: zod
                  .string()
                  .optional()
                  .describe(
                    "스토리지 내부 경로. 전달 시 백엔드가 매 조회마다 fresh signed URL을 재발급합니다.",
                  ),
                fileSize: zod.number().describe("파일 크기 (바이트)"),
                contentType: zod.string().optional().describe("MIME 타입"),
              })
              .strict(),
          )
          .nullish()
          .describe("첨부파일 목록"),
        responseCount: zod.number().describe("견적 응답 수"),
        responses: zod
          .array(
            zod
              .object({
                id: zod.string().describe("견적 응답 ID"),
                supplierName: zod.string().describe("공급자명"),
                supplierId: zod.string().describe("공급자 ID (세모 내부 UUID)"),
                supplierMemberId: zod
                  .string()
                  .nullable()
                  .describe(
                    "씨마켓 공급사 회원 ID. 익명화 대상이거나 씨마켓 회원이 아니면 null",
                  ),
                totalAmount: zod.number().describe("견적 금액"),
                trustScore: zod.number().describe("공급자 신뢰 점수"),
                trustPercentile: zod
                  .number()
                  .nullish()
                  .describe("공급자 신뢰 백분위"),
                chatRoomId: zod.string().nullable().describe("채팅방 ID"),
                isAnonymous: zod
                  .boolean()
                  .describe("익명 여부 (블러 처리 필요)"),
                isContracted: zod.boolean().describe("계약 여부 (채팅방 기준)"),
                withdrawnAt: zod
                  .string()
                  .datetime({})
                  .nullish()
                  .describe(
                    "공급사가 견적을 철회한 시각 (ISO 8601). null 이면 철회 안 됨",
                  ),
                attachments: zod
                  .array(
                    zod
                      .object({
                        fileName: zod.string().describe("파일명"),
                        url: zod.string().url().describe("파일 공개 URL"),
                        filePath: zod
                          .string()
                          .optional()
                          .describe(
                            "스토리지 내부 경로. 전달 시 백엔드가 매 조회마다 fresh signed URL을 재발급합니다.",
                          ),
                        fileSize: zod.number().describe("파일 크기 (바이트)"),
                        contentType: zod
                          .string()
                          .optional()
                          .describe("MIME 타입"),
                      })
                      .strict(),
                  )
                  .describe(
                    "공급사 첨부. URL 은 1시간 서명. 익명화 대상이면 빈 배열",
                  ),
                createdAt: zod.string().describe("생성일"),
              })
              .strict(),
          )
          .describe("견적 응답 목록"),
        willGenerateAutoQuotes: zod.boolean().describe("자동 견적 발송 여부"),
        autoQuoteStatus: zod
          .enum(["none", "pending", "processing", "completed", "failed"])
          .describe("스마트 견적 생성 상태"),
        contracts: zod
          .array(
            zod
              .object({
                id: zod.string().uuid().describe("계약 ID (UUID)"),
                contractNumber: zod.string().describe("계약 번호 (UI 표시용)"),
                status: zod
                  .enum(["IN_PROGRESS", "COMPLETED", "CANCELED"])
                  .describe("계약 상태"),
                isCanceled: zod.boolean().describe("계약 취소 여부"),
                cancellationRequestedAt: zod
                  .string()
                  .nullish()
                  .describe("계약 취소 요청 일시 (ISO 8601)"),
                canceledAt: zod
                  .string()
                  .nullish()
                  .describe("계약 취소 완료 일시 (ISO 8601)"),
                cancellationReason: zod
                  .string()
                  .nullish()
                  .describe("계약 취소 사유"),
                supplierId: zod
                  .string()
                  .uuid()
                  .describe("계약 공급사 ID (UUID)"),
                supplierName: zod
                  .string()
                  .nullish()
                  .describe(
                    "계약 공급사 상호. 씨마켓 «계약 업체» 칸이 그리는 값 — 참여 업체 목록과 짝맞추지 않아도 되도록 여기서 함께 내려보낸다.",
                  ),
                quoteResponseVersionId: zod
                  .string()
                  .uuid()
                  .nullish()
                  .describe(
                    "이 계약이 선 견적 응답 **버전** id. 씨마켓이 이 계약의 결제창을 되짚는 유일한 키다 — 결제창 발행 시 이 값을 멱등키로 보냈고, 씨마켓은 그 값으로 계약 ↔ 결제창을 1:1 로 묶어 두었다.",
                  ),
                paymentChannel: zod
                  .enum(["cash", "card"])
                  .nullish()
                  .describe(
                    "발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. NULL 은 채널 개념 이전의 레거시 계약(미상)이라 화면에서 임의로 접지 말 것.",
                  ),
                createdAt: zod.string().describe("계약 생성 일시 (ISO 8601)"),
              })
              .strict(),
          )
          .describe(
            "현재 사용자에게 노출 가능한 연결 계약 목록 (external 상세에서 제공)",
          ),
        dueDateValue: zod
          .enum(["구체적", "협의가능"])
          .nullish()
          .describe("배송일 (구체적/협의가능)"),
        dueDate: zod.string().nullish().describe("희망 배송일 (ISO 8601)"),
        additionalRequests: zod
          .array(
            zod
              .object({
                value: zod.string().describe("English code identifier"),
                label: zod.string().describe("Korean UI label for display"),
              })
              .strict(),
          )
          .nullish()
          .describe("추가 요청사항"),
        items: zod
          .array(
            zod
              .object({
                name: zod.string().describe("품목명"),
                quantity: zod.number().describe("수량"),
                unit: zod.string().describe("단위"),
                amount: zod.number().describe("금액"),
                spec1: zod.string().optional().describe("규격 1"),
                spec2: zod.string().optional().describe("규격 2"),
                spec3: zod.string().optional().describe("규격 3"),
                itemCode: zod.string().optional().describe("품목 코드"),
                manufacturer: zod.string().optional().describe("제조사"),
                brand: zod.string().optional().describe("브랜드"),
                itemId: zod.string().optional().describe("품목 ID"),
                itemName: zod
                  .string()
                  .optional()
                  .describe("매칭된 표준 품목명"),
                itemCodeMatch: zod
                  .string()
                  .optional()
                  .describe("매칭된 표준 품목 코드"),
                itemPrice: zod
                  .number()
                  .optional()
                  .describe("매칭된 표준 품목 단가"),
                itemImageUrl: zod
                  .string()
                  .optional()
                  .describe("매칭된 표준 품목 이미지 URL"),
                itemSpec: zod
                  .string()
                  .optional()
                  .describe("매칭된 표준 품목 규격 요약"),
              })
              .strict(),
          )
          .describe("물품 목록"),
        additionalConditions: zod
          .array(
            zod
              .object({
                value: zod.string().describe("English code identifier"),
                label: zod.string().describe("Korean UI label for display"),
              })
              .strict(),
          )
          .nullish()
          .describe("추가 조건"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 견적 요청 수정
 */
export const quoteRequestsControllerUpdateParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const quoteRequestsControllerUpdateBodyManagerNameMax = 100;

export const quoteRequestsControllerUpdateBodyPaymentMethodDefault = "postpaid";
export const quoteRequestsControllerUpdateBodyItemsItemAmountMin = 0;

export const quoteRequestsControllerUpdateBody = zod
  .object({
    projectName: zod
      .string()
      .optional()
      .describe(
        "프로젝트명 (물품 구매(product) 카테고리는 선택 — 미입력 시 물품 목록으로 자동 생성, 그 외 카테고리는 필수)",
      ),
    categoryType: zod
      .enum(["product", "construction", "manufacturing", "used"])
      .optional()
      .describe("카테고리 타입"),
    managerContact: zod.string().optional().describe("담당자 연락처 (필수)"),
    managerName: zod
      .string()
      .max(quoteRequestsControllerUpdateBodyManagerNameMax)
      .optional()
      .describe("담당자명"),
    addressId: zod
      .string()
      .optional()
      .describe("주소 ID (addresses 테이블 외래키)"),
    addressDetail: zod
      .string()
      .nullish()
      .describe("주소 상세정보 (예: 동 101호, 3층 등의 추가 정보)"),
    description: zod.string().nullish().describe("견적 요청 설명 및 추가 사항"),
    budgetType: zod
      .enum(["public", "no_budget"])
      .nullish()
      .describe("예산 타입"),
    budgetAmount: zod.number().nullish().describe("예산 금액 (원화)"),
    paymentMethod: zod
      .enum(["prepaid", "postpaid"])
      .default(quoteRequestsControllerUpdateBodyPaymentMethodDefault)
      .describe("결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)"),
    preferredPaymentChannel: zod
      .enum(["card", "cash", "undecided"])
      .optional()
      .describe(
        "공고 결제방법. card/cash/undecided. 미전달 시 미결정으로 취급. paymentMethod(선결제/후불)와 다른 축이다.",
      ),
    sameRegionOnly: zod.boolean().nullish().describe("동일 지역만 선택 여부"),
    isPublic: zod.boolean().nullish().describe("공개 여부"),
    dueDateValue: zod
      .enum(["구체적", "협의가능"])
      .nullish()
      .describe("배송일 값 (사용자 입력값)"),
    dueDate: zod.string().nullish().describe("배송일 (ISO 8601 형식)"),
    attachments: zod
      .array(
        zod
          .object({
            fileName: zod.string().describe("파일명"),
            url: zod.string().url().describe("파일 공개 URL"),
            filePath: zod
              .string()
              .optional()
              .describe(
                "스토리지 내부 경로. 전달 시 백엔드가 매 조회마다 fresh signed URL을 재발급합니다.",
              ),
            fileSize: zod.number().describe("파일 크기 (바이트)"),
            contentType: zod.string().optional().describe("MIME 타입"),
          })
          .strict(),
      )
      .nullish()
      .describe("업로드된 파일들의 메타데이터 배열"),
    items: zod
      .array(
        zod
          .object({
            name: zod.string().describe("품목명"),
            quantity: zod.number().min(1).describe("수량"),
            unit: zod.string().describe("단위 (예: 세트, EA, 박스)"),
            amount: zod
              .number()
              .min(quoteRequestsControllerUpdateBodyItemsItemAmountMin)
              .describe("금액 (원 단위, 예상 금액 또는 0)"),
            spec1: zod.string().optional().describe("규격 1"),
            spec2: zod.string().optional().describe("규격 2"),
            spec3: zod.string().optional().describe("규격 3"),
            itemCode: zod.string().optional().describe("품목 코드"),
            manufacturer: zod.string().optional().describe("제조사"),
            brand: zod.string().optional().describe("브랜드"),
            itemId: zod
              .string()
              .optional()
              .describe(
                "품목 ID (items_v2_base.id) - 자동완성 선택 시에만 제공",
              ),
          })
          .strict(),
      )
      .nullish()
      .describe("항목 목록 (Product 카테고리에만 필수)"),
    additionalConditions: zod
      .array(
        zod
          .object({
            value: zod.string().describe("English code identifier"),
            label: zod.string().describe("Korean UI label for display"),
          })
          .strict(),
      )
      .nullish()
      .describe("추가 조건 (물품 구매 카테고리 전용)"),
    additionalRequests: zod
      .array(
        zod
          .object({
            value: zod.string().describe("English code identifier"),
            label: zod.string().describe("Korean UI label for display"),
          })
          .strict(),
      )
      .nullish()
      .describe("추가 요청사항 (모든 카테고리 선택 가능)"),
    constructionType: zod
      .object({
        value: zod
          .enum([
            "facility_maintenance",
            "interior_architecture",
            "waterproofing_plaster_painting",
            "mechanical_equipment",
            "metal_structure_window",
            "paving",
            "electrical",
            "scaffolding_demolition",
            "asbestos_removal",
            "rebar_concrete",
            "fire_safety",
            "landscaping",
            "roofing_assembly",
            "elevator",
            "gas_facility",
            "hvac",
            "telecommunications",
            "cctv",
            "365_corner",
            "civil_construction",
            "building_construction",
            "specialized_construction",
            "water_sewage",
            "stone_work",
            "earthwork",
            "grouting",
            "dredging",
            "outdoor_signage",
            "other",
          ])
          .describe("Construction type code"),
        label: zod.string().describe("Korean label for display"),
      })
      .strict()
      .nullish()
      .describe("공사 타입 (공사 카테고리 전용)"),
    spaceType: zod
      .object({
        value: zod
          .enum(["office", "retail", "factory", "warehouse"])
          .describe("Space type code"),
        label: zod.string().describe("Korean label for display"),
      })
      .strict()
      .nullish()
      .describe("공간 타입 (공사 카테고리 전용)"),
    constructionArea: zod
      .object({
        value: zod
          .enum(["30", "50", "100", "200"])
          .describe("Construction area code"),
        label: zod.string().describe("Korean label for display"),
      })
      .strict()
      .nullish()
      .describe("공사 면적 (공사 카테고리 전용)"),
  })
  .strict();

export const quoteRequestsControllerUpdateResponseTwoDataPaymentMethodDefault =
  "postpaid";

export const quoteRequestsControllerUpdateResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("견적 요청 ID (UUID)"),
        requestNumber: zod.string().describe("견적 요청 번호"),
        projectName: zod.string().describe("프로젝트명"),
        userId: zod.string().describe("사용자 ID (작성자)"),
        isOwner: zod
          .boolean()
          .optional()
          .describe(
            "현재 인증 사용자가 이 견적 요청의 등록자인지 여부 (클라이언트 소유권 판단용)",
          ),
        status: zod
          .enum(["IN_PROGRESS", "ON_HOLD", "CLOSED", "CONTRACT_IN_PROGRESS"])
          .describe("상태"),
        categoryType: zod.enum(["product"]).describe("카테고리 타입"),
        managerName: zod.string().nullish().describe("담당자명"),
        managerContact: zod.string().nullish().describe("담당자 연락처"),
        organizationName: zod
          .string()
          .nullish()
          .describe(
            "발주기관 이름 (공개 공고에서만. 비공개 공고는 본인·어드민 외 null. 기관명이 없는 구매자는 null)",
          ),
        organizationPhone: zod
          .string()
          .nullish()
          .describe(
            "발주기관 대표번호 (담당자 개인 휴대폰이 아니다. 공개 공고에서만, 비공개는 본인·어드민 외 null)",
          ),
        addressId: zod.string().describe("주소 ID"),
        address: zod
          .object({
            province: zod.string().describe("시/도"),
            city: zod.string().describe("시/군/구"),
            district: zod.string().nullish().describe("읍/면/동"),
            label: zod
              .string()
              .nullish()
              .describe("배송지 이름 (예: 회사) (작성자 본인만)"),
            postalCode: zod
              .string()
              .nullish()
              .describe("우편번호 (작성자 본인만)"),
            addressLine1: zod
              .string()
              .nullish()
              .describe("기본주소 (작성자 본인만)"),
            addressLine2: zod
              .string()
              .nullish()
              .describe("상세주소 (작성자 본인만)"),
            recipientName: zod
              .string()
              .nullish()
              .describe("수령인 (작성자 본인만)"),
          })
          .strict()
          .nullish()
          .describe("주소 정보"),
        description: zod.string().nullish().describe("설명"),
        budgetType: zod
          .enum(["public", "no_budget"])
          .nullish()
          .describe("예산 타입"),
        budgetAmount: zod.number().nullish().describe("예산 금액"),
        paymentMethod: zod
          .enum(["prepaid", "postpaid"])
          .describe("결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)"),
        isPrepaid: zod
          .boolean()
          .describe("결제 방법 (boolean form). true=선결제, false=후불결제."),
        preferredPaymentChannel: zod
          .enum(["card", "cash", "undecided"])
          .nullable()
          .describe(
            "공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.",
          ),
        sameRegionOnly: zod.boolean().nullish().describe("동일 지역만"),
        isPublic: zod.boolean().nullish().describe("공개 여부"),
        deadline: zod.string().describe("마감일"),
        createdAt: zod.string().nullish().describe("생성일 (ISO 8601)"),
        updatedAt: zod.string().nullish().describe("수정일 (ISO 8601)"),
        approvedAt: zod.string().nullish().describe("승인 일시 (ISO 8601)"),
        closedAt: zod.string().nullish().describe("마감 일시 (ISO 8601)"),
        closeReason: zod.string().nullish().describe("마감 사유"),
        onHoldAt: zod.string().nullish().describe("보류 일시 (ISO 8601)"),
        attachments: zod
          .array(
            zod
              .object({
                fileName: zod.string().describe("파일명"),
                url: zod.string().url().describe("파일 공개 URL"),
                filePath: zod
                  .string()
                  .optional()
                  .describe(
                    "스토리지 내부 경로. 전달 시 백엔드가 매 조회마다 fresh signed URL을 재발급합니다.",
                  ),
                fileSize: zod.number().describe("파일 크기 (바이트)"),
                contentType: zod.string().optional().describe("MIME 타입"),
              })
              .strict(),
          )
          .nullish()
          .describe("첨부파일 목록"),
        responseCount: zod.number().describe("견적 응답 수"),
        responses: zod
          .array(
            zod
              .object({
                id: zod.string().describe("견적 응답 ID"),
                supplierName: zod.string().describe("공급자명"),
                supplierId: zod.string().describe("공급자 ID (세모 내부 UUID)"),
                supplierMemberId: zod
                  .string()
                  .nullable()
                  .describe(
                    "씨마켓 공급사 회원 ID. 익명화 대상이거나 씨마켓 회원이 아니면 null",
                  ),
                totalAmount: zod.number().describe("견적 금액"),
                trustScore: zod.number().describe("공급자 신뢰 점수"),
                trustPercentile: zod
                  .number()
                  .nullish()
                  .describe("공급자 신뢰 백분위"),
                chatRoomId: zod.string().nullable().describe("채팅방 ID"),
                isAnonymous: zod
                  .boolean()
                  .describe("익명 여부 (블러 처리 필요)"),
                isContracted: zod.boolean().describe("계약 여부 (채팅방 기준)"),
                withdrawnAt: zod
                  .string()
                  .datetime({})
                  .nullish()
                  .describe(
                    "공급사가 견적을 철회한 시각 (ISO 8601). null 이면 철회 안 됨",
                  ),
                attachments: zod
                  .array(
                    zod
                      .object({
                        fileName: zod.string().describe("파일명"),
                        url: zod.string().url().describe("파일 공개 URL"),
                        filePath: zod
                          .string()
                          .optional()
                          .describe(
                            "스토리지 내부 경로. 전달 시 백엔드가 매 조회마다 fresh signed URL을 재발급합니다.",
                          ),
                        fileSize: zod.number().describe("파일 크기 (바이트)"),
                        contentType: zod
                          .string()
                          .optional()
                          .describe("MIME 타입"),
                      })
                      .strict(),
                  )
                  .describe(
                    "공급사 첨부. URL 은 1시간 서명. 익명화 대상이면 빈 배열",
                  ),
                createdAt: zod.string().describe("생성일"),
              })
              .strict(),
          )
          .describe("견적 응답 목록"),
        willGenerateAutoQuotes: zod.boolean().describe("자동 견적 발송 여부"),
        autoQuoteStatus: zod
          .enum(["none", "pending", "processing", "completed", "failed"])
          .describe("스마트 견적 생성 상태"),
        contracts: zod
          .array(
            zod
              .object({
                id: zod.string().uuid().describe("계약 ID (UUID)"),
                contractNumber: zod.string().describe("계약 번호 (UI 표시용)"),
                status: zod
                  .enum(["IN_PROGRESS", "COMPLETED", "CANCELED"])
                  .describe("계약 상태"),
                isCanceled: zod.boolean().describe("계약 취소 여부"),
                cancellationRequestedAt: zod
                  .string()
                  .nullish()
                  .describe("계약 취소 요청 일시 (ISO 8601)"),
                canceledAt: zod
                  .string()
                  .nullish()
                  .describe("계약 취소 완료 일시 (ISO 8601)"),
                cancellationReason: zod
                  .string()
                  .nullish()
                  .describe("계약 취소 사유"),
                supplierId: zod
                  .string()
                  .uuid()
                  .describe("계약 공급사 ID (UUID)"),
                supplierName: zod
                  .string()
                  .nullish()
                  .describe(
                    "계약 공급사 상호. 씨마켓 «계약 업체» 칸이 그리는 값 — 참여 업체 목록과 짝맞추지 않아도 되도록 여기서 함께 내려보낸다.",
                  ),
                quoteResponseVersionId: zod
                  .string()
                  .uuid()
                  .nullish()
                  .describe(
                    "이 계약이 선 견적 응답 **버전** id. 씨마켓이 이 계약의 결제창을 되짚는 유일한 키다 — 결제창 발행 시 이 값을 멱등키로 보냈고, 씨마켓은 그 값으로 계약 ↔ 결제창을 1:1 로 묶어 두었다.",
                  ),
                paymentChannel: zod
                  .enum(["cash", "card"])
                  .nullish()
                  .describe(
                    "발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. NULL 은 채널 개념 이전의 레거시 계약(미상)이라 화면에서 임의로 접지 말 것.",
                  ),
                createdAt: zod.string().describe("계약 생성 일시 (ISO 8601)"),
              })
              .strict(),
          )
          .describe(
            "현재 사용자에게 노출 가능한 연결 계약 목록 (external 상세에서 제공)",
          ),
        dueDateValue: zod
          .enum(["구체적", "협의가능"])
          .nullish()
          .describe("배송일 (구체적/협의가능)"),
        dueDate: zod.string().nullish().describe("희망 배송일 (ISO 8601)"),
        additionalRequests: zod
          .array(
            zod
              .object({
                value: zod.string().describe("English code identifier"),
                label: zod.string().describe("Korean UI label for display"),
              })
              .strict(),
          )
          .nullish()
          .describe("추가 요청사항"),
        items: zod
          .array(
            zod
              .object({
                name: zod.string().describe("품목명"),
                quantity: zod.number().describe("수량"),
                unit: zod.string().describe("단위"),
                amount: zod.number().describe("금액"),
                spec1: zod.string().optional().describe("규격 1"),
                spec2: zod.string().optional().describe("규격 2"),
                spec3: zod.string().optional().describe("규격 3"),
                itemCode: zod.string().optional().describe("품목 코드"),
                manufacturer: zod.string().optional().describe("제조사"),
                brand: zod.string().optional().describe("브랜드"),
                itemId: zod.string().optional().describe("품목 ID"),
                itemName: zod
                  .string()
                  .optional()
                  .describe("매칭된 표준 품목명"),
                itemCodeMatch: zod
                  .string()
                  .optional()
                  .describe("매칭된 표준 품목 코드"),
                itemPrice: zod
                  .number()
                  .optional()
                  .describe("매칭된 표준 품목 단가"),
                itemImageUrl: zod
                  .string()
                  .optional()
                  .describe("매칭된 표준 품목 이미지 URL"),
                itemSpec: zod
                  .string()
                  .optional()
                  .describe("매칭된 표준 품목 규격 요약"),
              })
              .strict(),
          )
          .describe("물품 목록"),
        additionalConditions: zod
          .array(
            zod
              .object({
                value: zod.string().describe("English code identifier"),
                label: zod.string().describe("Korean UI label for display"),
              })
              .strict(),
          )
          .nullish()
          .describe("추가 조건"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 견적 요청 마감일 연장
 */
export const quoteRequestsControllerExtendDeadlineParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const quoteRequestsControllerExtendDeadlineResponseTwoDataPaymentMethodDefault =
  "postpaid";

export const quoteRequestsControllerExtendDeadlineResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("견적 요청 ID (UUID)"),
        requestNumber: zod.string().describe("견적 요청 번호"),
        projectName: zod.string().describe("프로젝트명"),
        userId: zod.string().describe("사용자 ID (작성자)"),
        isOwner: zod
          .boolean()
          .optional()
          .describe(
            "현재 인증 사용자가 이 견적 요청의 등록자인지 여부 (클라이언트 소유권 판단용)",
          ),
        status: zod
          .enum(["IN_PROGRESS", "ON_HOLD", "CLOSED", "CONTRACT_IN_PROGRESS"])
          .describe("상태"),
        categoryType: zod.enum(["product"]).describe("카테고리 타입"),
        managerName: zod.string().nullish().describe("담당자명"),
        managerContact: zod.string().nullish().describe("담당자 연락처"),
        organizationName: zod
          .string()
          .nullish()
          .describe(
            "발주기관 이름 (공개 공고에서만. 비공개 공고는 본인·어드민 외 null. 기관명이 없는 구매자는 null)",
          ),
        organizationPhone: zod
          .string()
          .nullish()
          .describe(
            "발주기관 대표번호 (담당자 개인 휴대폰이 아니다. 공개 공고에서만, 비공개는 본인·어드민 외 null)",
          ),
        addressId: zod.string().describe("주소 ID"),
        address: zod
          .object({
            province: zod.string().describe("시/도"),
            city: zod.string().describe("시/군/구"),
            district: zod.string().nullish().describe("읍/면/동"),
            label: zod
              .string()
              .nullish()
              .describe("배송지 이름 (예: 회사) (작성자 본인만)"),
            postalCode: zod
              .string()
              .nullish()
              .describe("우편번호 (작성자 본인만)"),
            addressLine1: zod
              .string()
              .nullish()
              .describe("기본주소 (작성자 본인만)"),
            addressLine2: zod
              .string()
              .nullish()
              .describe("상세주소 (작성자 본인만)"),
            recipientName: zod
              .string()
              .nullish()
              .describe("수령인 (작성자 본인만)"),
          })
          .strict()
          .nullish()
          .describe("주소 정보"),
        description: zod.string().nullish().describe("설명"),
        budgetType: zod
          .enum(["public", "no_budget"])
          .nullish()
          .describe("예산 타입"),
        budgetAmount: zod.number().nullish().describe("예산 금액"),
        paymentMethod: zod
          .enum(["prepaid", "postpaid"])
          .describe("결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)"),
        isPrepaid: zod
          .boolean()
          .describe("결제 방법 (boolean form). true=선결제, false=후불결제."),
        preferredPaymentChannel: zod
          .enum(["card", "cash", "undecided"])
          .nullable()
          .describe(
            "공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.",
          ),
        sameRegionOnly: zod.boolean().nullish().describe("동일 지역만"),
        isPublic: zod.boolean().nullish().describe("공개 여부"),
        deadline: zod.string().describe("마감일"),
        createdAt: zod.string().nullish().describe("생성일 (ISO 8601)"),
        updatedAt: zod.string().nullish().describe("수정일 (ISO 8601)"),
        approvedAt: zod.string().nullish().describe("승인 일시 (ISO 8601)"),
        closedAt: zod.string().nullish().describe("마감 일시 (ISO 8601)"),
        closeReason: zod.string().nullish().describe("마감 사유"),
        onHoldAt: zod.string().nullish().describe("보류 일시 (ISO 8601)"),
        attachments: zod
          .array(
            zod
              .object({
                fileName: zod.string().describe("파일명"),
                url: zod.string().url().describe("파일 공개 URL"),
                filePath: zod
                  .string()
                  .optional()
                  .describe(
                    "스토리지 내부 경로. 전달 시 백엔드가 매 조회마다 fresh signed URL을 재발급합니다.",
                  ),
                fileSize: zod.number().describe("파일 크기 (바이트)"),
                contentType: zod.string().optional().describe("MIME 타입"),
              })
              .strict(),
          )
          .nullish()
          .describe("첨부파일 목록"),
        responseCount: zod.number().describe("견적 응답 수"),
        responses: zod
          .array(
            zod
              .object({
                id: zod.string().describe("견적 응답 ID"),
                supplierName: zod.string().describe("공급자명"),
                supplierId: zod.string().describe("공급자 ID (세모 내부 UUID)"),
                supplierMemberId: zod
                  .string()
                  .nullable()
                  .describe(
                    "씨마켓 공급사 회원 ID. 익명화 대상이거나 씨마켓 회원이 아니면 null",
                  ),
                totalAmount: zod.number().describe("견적 금액"),
                trustScore: zod.number().describe("공급자 신뢰 점수"),
                trustPercentile: zod
                  .number()
                  .nullish()
                  .describe("공급자 신뢰 백분위"),
                chatRoomId: zod.string().nullable().describe("채팅방 ID"),
                isAnonymous: zod
                  .boolean()
                  .describe("익명 여부 (블러 처리 필요)"),
                isContracted: zod.boolean().describe("계약 여부 (채팅방 기준)"),
                withdrawnAt: zod
                  .string()
                  .datetime({})
                  .nullish()
                  .describe(
                    "공급사가 견적을 철회한 시각 (ISO 8601). null 이면 철회 안 됨",
                  ),
                attachments: zod
                  .array(
                    zod
                      .object({
                        fileName: zod.string().describe("파일명"),
                        url: zod.string().url().describe("파일 공개 URL"),
                        filePath: zod
                          .string()
                          .optional()
                          .describe(
                            "스토리지 내부 경로. 전달 시 백엔드가 매 조회마다 fresh signed URL을 재발급합니다.",
                          ),
                        fileSize: zod.number().describe("파일 크기 (바이트)"),
                        contentType: zod
                          .string()
                          .optional()
                          .describe("MIME 타입"),
                      })
                      .strict(),
                  )
                  .describe(
                    "공급사 첨부. URL 은 1시간 서명. 익명화 대상이면 빈 배열",
                  ),
                createdAt: zod.string().describe("생성일"),
              })
              .strict(),
          )
          .describe("견적 응답 목록"),
        willGenerateAutoQuotes: zod.boolean().describe("자동 견적 발송 여부"),
        autoQuoteStatus: zod
          .enum(["none", "pending", "processing", "completed", "failed"])
          .describe("스마트 견적 생성 상태"),
        contracts: zod
          .array(
            zod
              .object({
                id: zod.string().uuid().describe("계약 ID (UUID)"),
                contractNumber: zod.string().describe("계약 번호 (UI 표시용)"),
                status: zod
                  .enum(["IN_PROGRESS", "COMPLETED", "CANCELED"])
                  .describe("계약 상태"),
                isCanceled: zod.boolean().describe("계약 취소 여부"),
                cancellationRequestedAt: zod
                  .string()
                  .nullish()
                  .describe("계약 취소 요청 일시 (ISO 8601)"),
                canceledAt: zod
                  .string()
                  .nullish()
                  .describe("계약 취소 완료 일시 (ISO 8601)"),
                cancellationReason: zod
                  .string()
                  .nullish()
                  .describe("계약 취소 사유"),
                supplierId: zod
                  .string()
                  .uuid()
                  .describe("계약 공급사 ID (UUID)"),
                supplierName: zod
                  .string()
                  .nullish()
                  .describe(
                    "계약 공급사 상호. 씨마켓 «계약 업체» 칸이 그리는 값 — 참여 업체 목록과 짝맞추지 않아도 되도록 여기서 함께 내려보낸다.",
                  ),
                quoteResponseVersionId: zod
                  .string()
                  .uuid()
                  .nullish()
                  .describe(
                    "이 계약이 선 견적 응답 **버전** id. 씨마켓이 이 계약의 결제창을 되짚는 유일한 키다 — 결제창 발행 시 이 값을 멱등키로 보냈고, 씨마켓은 그 값으로 계약 ↔ 결제창을 1:1 로 묶어 두었다.",
                  ),
                paymentChannel: zod
                  .enum(["cash", "card"])
                  .nullish()
                  .describe(
                    "발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. NULL 은 채널 개념 이전의 레거시 계약(미상)이라 화면에서 임의로 접지 말 것.",
                  ),
                createdAt: zod.string().describe("계약 생성 일시 (ISO 8601)"),
              })
              .strict(),
          )
          .describe(
            "현재 사용자에게 노출 가능한 연결 계약 목록 (external 상세에서 제공)",
          ),
        dueDateValue: zod
          .enum(["구체적", "협의가능"])
          .nullish()
          .describe("배송일 (구체적/협의가능)"),
        dueDate: zod.string().nullish().describe("희망 배송일 (ISO 8601)"),
        additionalRequests: zod
          .array(
            zod
              .object({
                value: zod.string().describe("English code identifier"),
                label: zod.string().describe("Korean UI label for display"),
              })
              .strict(),
          )
          .nullish()
          .describe("추가 요청사항"),
        items: zod
          .array(
            zod
              .object({
                name: zod.string().describe("품목명"),
                quantity: zod.number().describe("수량"),
                unit: zod.string().describe("단위"),
                amount: zod.number().describe("금액"),
                spec1: zod.string().optional().describe("규격 1"),
                spec2: zod.string().optional().describe("규격 2"),
                spec3: zod.string().optional().describe("규격 3"),
                itemCode: zod.string().optional().describe("품목 코드"),
                manufacturer: zod.string().optional().describe("제조사"),
                brand: zod.string().optional().describe("브랜드"),
                itemId: zod.string().optional().describe("품목 ID"),
                itemName: zod
                  .string()
                  .optional()
                  .describe("매칭된 표준 품목명"),
                itemCodeMatch: zod
                  .string()
                  .optional()
                  .describe("매칭된 표준 품목 코드"),
                itemPrice: zod
                  .number()
                  .optional()
                  .describe("매칭된 표준 품목 단가"),
                itemImageUrl: zod
                  .string()
                  .optional()
                  .describe("매칭된 표준 품목 이미지 URL"),
                itemSpec: zod
                  .string()
                  .optional()
                  .describe("매칭된 표준 품목 규격 요약"),
              })
              .strict(),
          )
          .describe("물품 목록"),
        additionalConditions: zod
          .array(
            zod
              .object({
                value: zod.string().describe("English code identifier"),
                label: zod.string().describe("Korean UI label for display"),
              })
              .strict(),
          )
          .nullish()
          .describe("추가 조건"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 견적 요청 마감
 */
export const quoteRequestsControllerCloseQuoteRequestParams = zod
  .object({
    id: zod.coerce.string(),
  })
  .strict();

export const quoteRequestsControllerCloseQuoteRequestBody = zod
  .object({
    closeReason: zod.string().optional().describe("마감 사유"),
  })
  .strict();

export const quoteRequestsControllerCloseQuoteRequestResponseTwoDataPaymentMethodDefault =
  "postpaid";

export const quoteRequestsControllerCloseQuoteRequestResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("견적 요청 ID (UUID)"),
        requestNumber: zod.string().describe("견적 요청 번호"),
        projectName: zod.string().describe("프로젝트명"),
        userId: zod.string().describe("사용자 ID (작성자)"),
        isOwner: zod
          .boolean()
          .optional()
          .describe(
            "현재 인증 사용자가 이 견적 요청의 등록자인지 여부 (클라이언트 소유권 판단용)",
          ),
        status: zod
          .enum(["IN_PROGRESS", "ON_HOLD", "CLOSED", "CONTRACT_IN_PROGRESS"])
          .describe("상태"),
        categoryType: zod.enum(["product"]).describe("카테고리 타입"),
        managerName: zod.string().nullish().describe("담당자명"),
        managerContact: zod.string().nullish().describe("담당자 연락처"),
        organizationName: zod
          .string()
          .nullish()
          .describe(
            "발주기관 이름 (공개 공고에서만. 비공개 공고는 본인·어드민 외 null. 기관명이 없는 구매자는 null)",
          ),
        organizationPhone: zod
          .string()
          .nullish()
          .describe(
            "발주기관 대표번호 (담당자 개인 휴대폰이 아니다. 공개 공고에서만, 비공개는 본인·어드민 외 null)",
          ),
        addressId: zod.string().describe("주소 ID"),
        address: zod
          .object({
            province: zod.string().describe("시/도"),
            city: zod.string().describe("시/군/구"),
            district: zod.string().nullish().describe("읍/면/동"),
            label: zod
              .string()
              .nullish()
              .describe("배송지 이름 (예: 회사) (작성자 본인만)"),
            postalCode: zod
              .string()
              .nullish()
              .describe("우편번호 (작성자 본인만)"),
            addressLine1: zod
              .string()
              .nullish()
              .describe("기본주소 (작성자 본인만)"),
            addressLine2: zod
              .string()
              .nullish()
              .describe("상세주소 (작성자 본인만)"),
            recipientName: zod
              .string()
              .nullish()
              .describe("수령인 (작성자 본인만)"),
          })
          .strict()
          .nullish()
          .describe("주소 정보"),
        description: zod.string().nullish().describe("설명"),
        budgetType: zod
          .enum(["public", "no_budget"])
          .nullish()
          .describe("예산 타입"),
        budgetAmount: zod.number().nullish().describe("예산 금액"),
        paymentMethod: zod
          .enum(["prepaid", "postpaid"])
          .describe("결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)"),
        isPrepaid: zod
          .boolean()
          .describe("결제 방법 (boolean form). true=선결제, false=후불결제."),
        preferredPaymentChannel: zod
          .enum(["card", "cash", "undecided"])
          .nullable()
          .describe(
            "공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.",
          ),
        sameRegionOnly: zod.boolean().nullish().describe("동일 지역만"),
        isPublic: zod.boolean().nullish().describe("공개 여부"),
        deadline: zod.string().describe("마감일"),
        createdAt: zod.string().nullish().describe("생성일 (ISO 8601)"),
        updatedAt: zod.string().nullish().describe("수정일 (ISO 8601)"),
        approvedAt: zod.string().nullish().describe("승인 일시 (ISO 8601)"),
        closedAt: zod.string().nullish().describe("마감 일시 (ISO 8601)"),
        closeReason: zod.string().nullish().describe("마감 사유"),
        onHoldAt: zod.string().nullish().describe("보류 일시 (ISO 8601)"),
        attachments: zod
          .array(
            zod
              .object({
                fileName: zod.string().describe("파일명"),
                url: zod.string().url().describe("파일 공개 URL"),
                filePath: zod
                  .string()
                  .optional()
                  .describe(
                    "스토리지 내부 경로. 전달 시 백엔드가 매 조회마다 fresh signed URL을 재발급합니다.",
                  ),
                fileSize: zod.number().describe("파일 크기 (바이트)"),
                contentType: zod.string().optional().describe("MIME 타입"),
              })
              .strict(),
          )
          .nullish()
          .describe("첨부파일 목록"),
        responseCount: zod.number().describe("견적 응답 수"),
        responses: zod
          .array(
            zod
              .object({
                id: zod.string().describe("견적 응답 ID"),
                supplierName: zod.string().describe("공급자명"),
                supplierId: zod.string().describe("공급자 ID (세모 내부 UUID)"),
                supplierMemberId: zod
                  .string()
                  .nullable()
                  .describe(
                    "씨마켓 공급사 회원 ID. 익명화 대상이거나 씨마켓 회원이 아니면 null",
                  ),
                totalAmount: zod.number().describe("견적 금액"),
                trustScore: zod.number().describe("공급자 신뢰 점수"),
                trustPercentile: zod
                  .number()
                  .nullish()
                  .describe("공급자 신뢰 백분위"),
                chatRoomId: zod.string().nullable().describe("채팅방 ID"),
                isAnonymous: zod
                  .boolean()
                  .describe("익명 여부 (블러 처리 필요)"),
                isContracted: zod.boolean().describe("계약 여부 (채팅방 기준)"),
                withdrawnAt: zod
                  .string()
                  .datetime({})
                  .nullish()
                  .describe(
                    "공급사가 견적을 철회한 시각 (ISO 8601). null 이면 철회 안 됨",
                  ),
                attachments: zod
                  .array(
                    zod
                      .object({
                        fileName: zod.string().describe("파일명"),
                        url: zod.string().url().describe("파일 공개 URL"),
                        filePath: zod
                          .string()
                          .optional()
                          .describe(
                            "스토리지 내부 경로. 전달 시 백엔드가 매 조회마다 fresh signed URL을 재발급합니다.",
                          ),
                        fileSize: zod.number().describe("파일 크기 (바이트)"),
                        contentType: zod
                          .string()
                          .optional()
                          .describe("MIME 타입"),
                      })
                      .strict(),
                  )
                  .describe(
                    "공급사 첨부. URL 은 1시간 서명. 익명화 대상이면 빈 배열",
                  ),
                createdAt: zod.string().describe("생성일"),
              })
              .strict(),
          )
          .describe("견적 응답 목록"),
        willGenerateAutoQuotes: zod.boolean().describe("자동 견적 발송 여부"),
        autoQuoteStatus: zod
          .enum(["none", "pending", "processing", "completed", "failed"])
          .describe("스마트 견적 생성 상태"),
        contracts: zod
          .array(
            zod
              .object({
                id: zod.string().uuid().describe("계약 ID (UUID)"),
                contractNumber: zod.string().describe("계약 번호 (UI 표시용)"),
                status: zod
                  .enum(["IN_PROGRESS", "COMPLETED", "CANCELED"])
                  .describe("계약 상태"),
                isCanceled: zod.boolean().describe("계약 취소 여부"),
                cancellationRequestedAt: zod
                  .string()
                  .nullish()
                  .describe("계약 취소 요청 일시 (ISO 8601)"),
                canceledAt: zod
                  .string()
                  .nullish()
                  .describe("계약 취소 완료 일시 (ISO 8601)"),
                cancellationReason: zod
                  .string()
                  .nullish()
                  .describe("계약 취소 사유"),
                supplierId: zod
                  .string()
                  .uuid()
                  .describe("계약 공급사 ID (UUID)"),
                supplierName: zod
                  .string()
                  .nullish()
                  .describe(
                    "계약 공급사 상호. 씨마켓 «계약 업체» 칸이 그리는 값 — 참여 업체 목록과 짝맞추지 않아도 되도록 여기서 함께 내려보낸다.",
                  ),
                quoteResponseVersionId: zod
                  .string()
                  .uuid()
                  .nullish()
                  .describe(
                    "이 계약이 선 견적 응답 **버전** id. 씨마켓이 이 계약의 결제창을 되짚는 유일한 키다 — 결제창 발행 시 이 값을 멱등키로 보냈고, 씨마켓은 그 값으로 계약 ↔ 결제창을 1:1 로 묶어 두었다.",
                  ),
                paymentChannel: zod
                  .enum(["cash", "card"])
                  .nullish()
                  .describe(
                    "발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. NULL 은 채널 개념 이전의 레거시 계약(미상)이라 화면에서 임의로 접지 말 것.",
                  ),
                createdAt: zod.string().describe("계약 생성 일시 (ISO 8601)"),
              })
              .strict(),
          )
          .describe(
            "현재 사용자에게 노출 가능한 연결 계약 목록 (external 상세에서 제공)",
          ),
        dueDateValue: zod
          .enum(["구체적", "협의가능"])
          .nullish()
          .describe("배송일 (구체적/협의가능)"),
        dueDate: zod.string().nullish().describe("희망 배송일 (ISO 8601)"),
        additionalRequests: zod
          .array(
            zod
              .object({
                value: zod.string().describe("English code identifier"),
                label: zod.string().describe("Korean UI label for display"),
              })
              .strict(),
          )
          .nullish()
          .describe("추가 요청사항"),
        items: zod
          .array(
            zod
              .object({
                name: zod.string().describe("품목명"),
                quantity: zod.number().describe("수량"),
                unit: zod.string().describe("단위"),
                amount: zod.number().describe("금액"),
                spec1: zod.string().optional().describe("규격 1"),
                spec2: zod.string().optional().describe("규격 2"),
                spec3: zod.string().optional().describe("규격 3"),
                itemCode: zod.string().optional().describe("품목 코드"),
                manufacturer: zod.string().optional().describe("제조사"),
                brand: zod.string().optional().describe("브랜드"),
                itemId: zod.string().optional().describe("품목 ID"),
                itemName: zod
                  .string()
                  .optional()
                  .describe("매칭된 표준 품목명"),
                itemCodeMatch: zod
                  .string()
                  .optional()
                  .describe("매칭된 표준 품목 코드"),
                itemPrice: zod
                  .number()
                  .optional()
                  .describe("매칭된 표준 품목 단가"),
                itemImageUrl: zod
                  .string()
                  .optional()
                  .describe("매칭된 표준 품목 이미지 URL"),
                itemSpec: zod
                  .string()
                  .optional()
                  .describe("매칭된 표준 품목 규격 요약"),
              })
              .strict(),
          )
          .describe("물품 목록"),
        additionalConditions: zod
          .array(
            zod
              .object({
                value: zod.string().describe("English code identifier"),
                label: zod.string().describe("Korean UI label for display"),
              })
              .strict(),
          )
          .nullish()
          .describe("추가 조건"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 공개 견적 요청 목록 조회
 */
export const publicQuoteRequestsControllerFindPublicQueryPageDefault = 1;

export const publicQuoteRequestsControllerFindPublicQueryLimitDefault = 20;
export const publicQuoteRequestsControllerFindPublicQueryLimitMax = 100;

export const publicQuoteRequestsControllerFindPublicQuerySortByDefault =
  "created_at";
export const publicQuoteRequestsControllerFindPublicQuerySortOrderDefault =
  "desc";

export const publicQuoteRequestsControllerFindPublicQueryParams = zod
  .object({
    page: zod.coerce
      .number()
      .min(1)
      .default(publicQuoteRequestsControllerFindPublicQueryPageDefault)
      .describe("페이지 번호"),
    limit: zod.coerce
      .number()
      .min(1)
      .max(publicQuoteRequestsControllerFindPublicQueryLimitMax)
      .default(publicQuoteRequestsControllerFindPublicQueryLimitDefault)
      .describe("페이지당 항목 수"),
    sortBy: zod.coerce
      .string()
      .default(publicQuoteRequestsControllerFindPublicQuerySortByDefault)
      .describe("정렬 필드"),
    sortOrder: zod
      .enum(["asc", "desc"])
      .default(publicQuoteRequestsControllerFindPublicQuerySortOrderDefault)
      .describe("정렬 순서"),
    search: zod.coerce.string().optional().describe("검색어"),
  })
  .strict();

export const publicQuoteRequestsControllerFindPublicResponseTwoDataItemsItemPaymentMethodDefault =
  "postpaid";

export const publicQuoteRequestsControllerFindPublicResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod.string().describe("견적 요청 ID (UUID)"),
              requestNumber: zod.string().describe("견적 요청 번호"),
              projectName: zod.string().describe("프로젝트명"),
              organizationName: zod
                .string()
                .nullish()
                .describe(
                  "발주기관 이름 (공개 공고에서만. 비공개 공고는 본인·어드민 외 null. 기관명이 없는 구매자는 null)",
                ),
              status: zod
                .enum([
                  "IN_PROGRESS",
                  "ON_HOLD",
                  "CLOSED",
                  "CONTRACT_IN_PROGRESS",
                ])
                .describe("상태"),
              categoryType: zod
                .enum(["product", "construction", "manufacturing", "used"])
                .describe("카테고리 타입"),
              deadline: zod.string().describe("마감일"),
              createdAt: zod.string().nullish().describe("생성일 (ISO 8601)"),
              updatedAt: zod.string().nullish().describe("수정일 (ISO 8601)"),
              userId: zod.string().describe("사용자 ID (UUID)"),
              managerName: zod.string().nullish().describe("담당자명"),
              managerContact: zod.string().nullish().describe("담당자 연락처"),
              addressId: zod.string().nullish().describe("주소 ID"),
              address: zod
                .object({
                  province: zod.string().describe("시/도"),
                  city: zod.string().describe("시/군/구"),
                  district: zod.string().nullish().describe("읍/면/동"),
                  label: zod
                    .string()
                    .nullish()
                    .describe("배송지 이름 (예: 회사) (작성자 본인만)"),
                  postalCode: zod
                    .string()
                    .nullish()
                    .describe("우편번호 (작성자 본인만)"),
                  addressLine1: zod
                    .string()
                    .nullish()
                    .describe("기본주소 (작성자 본인만)"),
                  addressLine2: zod
                    .string()
                    .nullish()
                    .describe("상세주소 (작성자 본인만)"),
                  recipientName: zod
                    .string()
                    .nullish()
                    .describe("수령인 (작성자 본인만)"),
                })
                .strict()
                .nullish()
                .describe("지역 정보"),
              sameRegionOnly: zod.boolean().nullish().describe("동일 지역만"),
              budgetType: zod
                .enum(["public", "no_budget"])
                .nullish()
                .describe("예산 타입"),
              budgetAmount: zod.number().nullish().describe("예산 금액"),
              paymentMethod: zod
                .enum(["prepaid", "postpaid"])
                .describe(
                  "결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)",
                ),
              isPrepaid: zod
                .boolean()
                .describe(
                  "결제 방법 (boolean form). true=선결제, false=후불결제.",
                ),
              preferredPaymentChannel: zod
                .enum(["card", "cash", "undecided"])
                .nullable()
                .describe(
                  "공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.",
                ),
              isPublic: zod.boolean().nullish().describe("공개 여부"),
              dueDateValue: zod
                .enum(["구체적", "협의가능"])
                .nullish()
                .describe("배송일 (구체적/협의가능)"),
              dueDate: zod
                .string()
                .nullish()
                .describe("희망 배송일 (ISO 8601)"),
              constructionType: zod
                .object({
                  value: zod
                    .enum([
                      "facility_maintenance",
                      "interior_architecture",
                      "waterproofing_plaster_painting",
                      "mechanical_equipment",
                      "metal_structure_window",
                      "paving",
                      "electrical",
                      "scaffolding_demolition",
                      "asbestos_removal",
                      "rebar_concrete",
                      "fire_safety",
                      "landscaping",
                      "roofing_assembly",
                      "elevator",
                      "gas_facility",
                      "hvac",
                      "telecommunications",
                      "cctv",
                      "365_corner",
                      "civil_construction",
                      "building_construction",
                      "specialized_construction",
                      "water_sewage",
                      "stone_work",
                      "earthwork",
                      "grouting",
                      "dredging",
                      "outdoor_signage",
                      "other",
                    ])
                    .describe("Construction type code"),
                  label: zod.string().describe("Korean label for display"),
                })
                .strict()
                .nullish()
                .describe("공사 유형"),
              spaceType: zod
                .object({
                  value: zod
                    .enum(["office", "retail", "factory", "warehouse"])
                    .describe("Space type code"),
                  label: zod.string().describe("Korean label for display"),
                })
                .strict()
                .nullish()
                .describe("공간 유형"),
              constructionArea: zod
                .object({
                  value: zod
                    .enum(["30", "50", "100", "200"])
                    .describe("Construction area code"),
                  label: zod.string().describe("Korean label for display"),
                })
                .strict()
                .nullish()
                .describe("공사 면적"),
              responseCount: zod.number().describe("받은 견적 응답 개수"),
              hasResponded: zod
                .boolean()
                .nullish()
                .describe("현재 판매자의 응답 여부"),
              quoteResponseId: zod
                .string()
                .optional()
                .describe("판매자가 작성한 견적 응답 ID"),
              canAutoQuote: zod
                .boolean()
                .optional()
                .describe("자동 견적 가능 여부 (공급자 전용)"),
              hasMyContract: zod
                .boolean()
                .nullish()
                .describe(
                  "현재 판매자 본인의 비취소 계약 존재 여부 (공급자 전용). 견적요청 단위 status=CONTRACT_IN_PROGRESS 와 달리 타사 계약에는 켜지지 않는다. null=판정 불가(발주기관 조회 등).",
                ),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();
